export default "__VITE_PUBLIC_ASSET__9aeecec9__"